import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { TranslocoModule } from '@ngneat/transloco';
import { TranslocoLocaleModule } from '@ngneat/transloco-locale';
import { CommonUserProfileWordingModule } from '@platform-frontend/account-ui';
import { CountryModule } from '@platform-frontend/marketplace';
import {
  ButtonModule,
  CardModule,
  CommonWordingModule,
  DateSelectionModule,
  FormsModule,
  IconsModule,
  icoPerson,
  icoPersons,
  icoPlusCircleDuo,
  LinkModule,
  TabSelectableModule,
  TemplateVariablesModule,
  ToggleModule
} from '@platform-frontend/ui-tools';
import { NgxMaskModule } from 'ngx-mask';
import { MatomoTrackClickDirective } from 'ngx-matomo-client';
import { TranslocoMarkupModule } from 'ngx-transloco-markup';
import { ButtonAddPersonComponent } from './button-add-person/button-add-person';
import { CreatePersonComponent } from './create-person/create-person.component';
import { MultiplePersonComponent } from './multiple-person/multiple-person.component';
import { SelectedPersonCardComponent } from './selected-person-card/selected-person-card.component';
import { SelectedPersonCardPipe } from './selected-person-card/selected-person-card.pipe';

@NgModule({
  declarations: [ButtonAddPersonComponent, CreatePersonComponent, MultiplePersonComponent, SelectedPersonCardComponent, SelectedPersonCardPipe],
  exports: [ButtonAddPersonComponent, CreatePersonComponent, MultiplePersonComponent, SelectedPersonCardComponent],
  imports: [
    BrowserModule,
    ButtonModule,
    CommonModule,
    CommonWordingModule,
    CommonUserProfileWordingModule,
    CardModule,
    CountryModule,
    DateSelectionModule,
    FormsModule,
    LinkModule,
    IconsModule.withIcons(icoPerson, icoPersons, icoPlusCircleDuo),
    MatomoTrackClickDirective,
    NgxMaskModule.forChild(),
    ReactiveFormsModule,
    TabSelectableModule,
    TemplateVariablesModule,
    TranslocoLocaleModule,
    TranslocoMarkupModule,
    TranslocoModule,
    ToggleModule
  ]
})
export class PersonalizationModule {}
